import { z } from "zod";
import { actionKindSchema, checkInChannelSchema, staffTitleSchema } from "./actions.js";
/* A client's own view of the actions their care team marked "shown in app"
 * (GET /client/plan). Narrower than PatientAction on purpose: no author id,
 * source message, version link or change reason, and no check-in notes —
 * those were written in the clinic without a "the client sees this" cue.
 * Only the current version of each active action is ever sent.
 */
const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const clientPlanItemSchema = z.object({
    id: z.string(),
    kind: actionKindSchema,
    title: z.string(),
    instructions: z.string().nullable(),
    runsForWeeks: z.number().int().nullable(),
    // The action's createdAt as a Europe/Helsinki calendar date; the client
    // only formats it.
    startedOn: isoDateSchema,
    checkInOn: isoDateSchema.nullable(),
    checkInChannel: checkInChannelSchema.nullable(),
    authorName: z.string(),
    authorTitle: staffTitleSchema,
});
// Read-lenient on the enums, same rationale as readHomeBlockSchema: a new
// kind, channel or title on the server must not blank the card on a stale PWA.
export const readClientPlanItemSchema = clientPlanItemSchema.extend({
    kind: z.string(),
    checkInChannel: z.string().nullable(),
    authorTitle: z.string(),
});
export const clientPlanSchema = z.object({ items: z.array(clientPlanItemSchema) });
export const readClientPlanSchema = z.object({ items: z.array(readClientPlanItemSchema) });
